import { render, staticRenderFns } from "./DialogYoutube.vue?vue&type=template&id=ee4fb988&"
import script from "./DialogYoutube.vue?vue&type=script&lang=js&"
export * from "./DialogYoutube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports